import { render, staticRenderFns } from "./ProductIntroColumn.vue?vue&type=template&id=47a9166a&scoped=true"
import script from "./ProductIntroColumn.vue?vue&type=script&lang=js"
export * from "./ProductIntroColumn.vue?vue&type=script&lang=js"
import style0 from "./ProductIntroColumn.vue?vue&type=style&index=0&id=47a9166a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a9166a",
  null
  
)

export default component.exports